import React from 'react';

const PackageSelectModal = ({ state }) => {
  const {
    packages,
    addToPackage,
    createNewPackage,
    setShowPackageModal,
  } = state;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#1e1e32',
        borderRadius: 16,
        padding: 32,
        width: '100%',
        maxWidth: 500,
        border: '1px solid #2d2d44'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#f3f4f6' }}>Add to Package</h3>
          <button
            onClick={() => setShowPackageModal(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              fontSize: 24,
              cursor: 'pointer'
            }}
          >
            {'\u00D7'}
          </button>
        </div>

        <div style={{ marginBottom: 24 }}>
          <p style={{ margin: '0 0 16px', fontSize: 13, color: '#9ca3af' }}>
            Select an existing package or create a new one:
          </p>

          {/* Existing Packages */}
          <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
            {packages.filter(p => p.status === 'in_progress').map(pkg => (
              <div
                key={pkg.id}
                onClick={() => addToPackage(pkg.id)}
                style={{
                  padding: 16,
                  backgroundColor: '#252540',
                  borderRadius: 8,
                  cursor: 'pointer',
                  border: '1px solid #374151',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.borderColor = '#8b5cf6'}
                onMouseOut={(e) => e.currentTarget.style.borderColor = '#374151'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h4 style={{ margin: '0 0 4px', fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>{pkg.name}</h4>
                    <p style={{ margin: 0, fontSize: 12, color: '#6b7280' }}>
                      {pkg.briefs.length} brief{pkg.briefs.length !== 1 ? 's' : ''} {'\u2022'} Created {pkg.createdAt}
                    </p>
                  </div>
                  <span style={{
                    padding: '2px 8px',
                    backgroundColor: '#8b5cf620',
                    borderRadius: 4,
                    fontSize: 11,
                    color: '#a78bfa'
                  }}>
                    In Progress
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                  {pkg.categories.map((cat, idx) => (
                    <span key={idx} style={{
                      padding: '2px 6px',
                      backgroundColor: '#374151',
                      borderRadius: 3,
                      fontSize: 10,
                      color: '#9ca3af'
                    }}>
                      {cat}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Create New Package */}
          <button
            onClick={createNewPackage}
            style={{
              width: '100%',
              padding: 16,
              backgroundColor: 'transparent',
              border: '2px dashed #374151',
              borderRadius: 8,
              color: '#9ca3af',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = '#8b5cf6';
              e.currentTarget.style.color = '#f3f4f6';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = '#374151';
              e.currentTarget.style.color = '#9ca3af';
            }}
          >
            <span style={{ fontSize: 18 }}>+</span>
            Create New Package
          </button>
        </div>
      </div>
    </div>
  );
};

export default PackageSelectModal;
